import { html, LitElement, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

import '../parts/card';
import '../parts/monster';
import '../parts/event';
import '../parts/status';
import '../components/card';
import '../components/decklist';
import '../components/comments';

import style from './card.scss';
import { processDesc, processEffect, processLog } from '../shared/parse';
import { DATA_KEYWORDS, DATA_STATUS } from '../data/sources';
import { friendlyURL, getNameFromURL, setTitle, trackPage } from '../shared/utils';

export class CardPage extends LitElement {

    static get properties() {
        return {
            id: Number,
            data: Object
        }
    }

    constructor() {
        super();
        this.id = null;
        this.data = null;
        this.talent = false;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();
        this.id = getNameFromURL();
        this.fetchData();
    }

    async fetchData() {
        if (!this.id) {
            return;
        }
        if (window.location.href.toLowerCase().indexOf('talent') !== -1) {
            this.talent = true;
        }
        let cardjson = await fetch(`./api/card/${this.id}${window.location.search ? window.location.search + '&' : '?'}talent=${this.talent}`);
        let card = await cardjson.json();
        if (!window.location.search && !isNaN(this.id)) {
            window.location = `./${this.talent === 'true' ? 'talent' : 'card'}/${friendlyURL(card.name)}`;
            return;
        }
        setTitle(card.name);
        this.data = card;
    }

    render() {
        if (!this.data)
            return html``;
        let ver = '';
        if (window.location.search)
            ver = window.location.search.split('=')[1];
        return html`
            <h1>${this.data.nameLocalized||this.data.name}${ver ? ` (v${ver.replace(/\-/g, '.')})` : ''}</h1>
            <card-component id=${this.id} ver=${ver} talent=${this.talent}></card-component>
            ${(this.data.keywords || []).map(keyword => {
            let kw = Object.keys(DATA_KEYWORDS).filter(k => k.toLowerCase() === keyword);
            if (kw.length > 0) {
                return html`
                    <div class="bubble keyword">
                        <div class="keyword-heading">${keyword.toUpperCase()}</div>
                        ${DATA_KEYWORDS[kw[0]]}
                    </div>
                    `;
            } else {
                let st = DATA_STATUS.filter(k => k.name.toLowerCase() === keyword);
                if (st.length > 0)
                    return html`
                        <div class="bubble keyword">
                            <div class="keyword-heading">${keyword.toUpperCase()}</div>
                            ${unsafeHTML(processDesc(st[0].desc))}
                        </div>
                        `;
            }
        })}          
            ${this.data.prereq && this.data.prereq.length > 0 ? html`
            <h3>Prerequisites</h3>
            ${this.data.prereq.map(pre => {
            return html`
                    <div class="row">
                        <card-part id="${pre}" talent="true"></card-part>
                    </div>                    
                `;
        })}
            `: ''}
            ${this.data.ispreq && this.data.ispreq.length > 0 ? html`
            <h3>Is Prerequisite For</h3>
            ${this.data.ispreq.map(pre => {
            return html`
                    <div class="row">
                        <card-part id="${pre}" talent="true"></card-part>
                    </div>
                `;
        })}
            `: ''}
            ${this.data.effects && this.data.effects.length > 0 ? html`
            <h3>Card Effects</h3>
            ${this.data.effects.map(eff => {
            return processEffect(eff);
        })}
            `: ''}     
            ${this.data.enchants && this.data.enchants.length > 0 ? html`
            <h3>Card Enchantments</h3>
            ${this.data.enchants.map(eff => {
            return processEffect(eff);
        })}
            `: ''}     
            ${this.data.monsters && this.data.monsters.length > 0 ? html`
            <h3>Used By</h3>
            ${this.data.monsters.map(mon => html`
                <div class="row">
                    <monster-part id=${mon}></monster-part>
                </div>
            `)}
            `: ''}      
            ${this.data.events && this.data.events.length > 0 ? html`
            <h3>Related Events (${this.data.events.length})</h3>
            ${this.data.events.map(e => html`
                <div class="row">
                    <event-part id=${e}></event-part>
                </div>
            `)}
            `: ''}  
            ${this.data.transmute && this.data.transmute.length > 0 ? html`
            <h3>Transmutes To (${this.data.transmute.length})</h3>
            ${this.data.transmute.map(c => html`
                <div class="row">
                    <card-part id=${c}></card-part>
                </div>
            `)}
            `: ''}       
            ${this.data.changelog && !ver ? html`                
                <h3>Old Versions</h3>
                ${Object.keys(this.data.changelog).map(ver => {
            return html`
                        <h4><a href="./cardarchive/${this.data.id}?ver=${ver}">Version ${ver.replace(/\-/g, '.')}</a></h4>
                        <ul>
                        ${this.data.changelog[ver].map(l => {
                return processLog(l);
            })}
                        </ul>
                    `;
        })}
            `: ''}        
            ${!ver ? html`
            <decklist-component url=${`deckcard/${this.data.name}`} autohide="true"></decklist-component>   
            <decklist-component url=${`sunforgecard/${this.data.name}`} autohide="true" title="Trial of the Sunforge Runs"></decklist-component>   
            <comments-component path=${`/card/${this.data.id}`}></comments-component>
            `: ''}                                          
        `;
    }
}

customElements.define('card-page', CardPage);